(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('ApplicationService', ApplicationService)

    /** @ngInject */
    function ApplicationService(HttpService) {
        const ApplicationService = {
            getAll: getAll,
            getHighlighted: getHighlighted
        }

        return ApplicationService;

        function getAll() {
            return HttpService.get('/applications/all');
        }

        function getHighlighted(unitEmail) {
            let url = `/applications/all?getHighlighted=true`;

            if (unitEmail)
                url += `&unitEmail=${unitEmail}`;

            return HttpService.get(url);
        }
    }
}());